<template>
  <div class="error-page">
    <div class="logo"></div>
    <div class="error-wrapper">
      <div class="img"></div>
      <h1>Forbid</h1>
      <p>You don't have permission to access this resource / page.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error",
  methods: {
    goBack() {
      if (window.history.length <= 1) {
        this.$router.push("/");
        return false;
      } else {
        this.$router.go(-1);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.error-page {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #ffffff;
  position: relative;
  height: 100%;
  
  .logo {
    position: absolute;
    top: 50px;
    left: 50px;
    width: 120px;
    height: 70px;
    background-size: cover;
    background-image: url("../../assets/img/logo.png");
  }

  .error-wrapper {
    text-align: center;
    .img {
      margin-left: 35px;
      width: 500px;
      height: 285px;
      background-size: cover;
      background-image: url("../../assets/img/404or500.png");
    }

    h1 {
      font-size: 3em;
      line-height: 2.5;
      color: #ee7765;
    }

    p {
      color: #aaaaaa;
      margin-bottom: 30px;
      font-size: 16px;
    }

    button {
      outline: 0;
      border: none;
      background-color: #d52b1e;
      color: #ffffff;
      line-height: 1;
      white-space: nowrap;
      cursor: pointer;
      -webkit-appearance: none;
      text-align: center;
      box-sizing: border-box;
      outline: none;
      margin: 0;
      transition: 0.1s;
      font-weight: bold;
      -moz-user-select: none;
      -webkit-user-select: none;
      -ms-user-select: none;
      padding: 12px 20px;
      font-size: 14px;
      border-radius: 4px;
    }
  }
}
</style>
